module.exports = __webpack_public_path__ + "img/数据分析小助手二维码.d969e5df.jpg";